// Upload flipcard image to remote api
const uploadImage = async (file: File, imageUploadUrl: string) => {
  const formData = new FormData();
  formData.append('image', file);
  formData.append('size', '250');
  try {
    const response = await fetch(imageUploadUrl, {
      method: 'POST',
      body: formData
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data.dataValue;
  } catch (error) {
    console.error('Upload failed:', error);
    throw error;
  }
}

export default {
  uploadImage
}
